import React,{useEffect,useState} from 'react';
import { Container } from 'react-bootstrap';
import Axios from '../../lib/axios/axiosInstance';

import services from '../../mockups/homeServices.json'
import './OurServices.styles.css';

const OurServices = ({ firstProp, secondProp }) => {

  const [serviceList,setServiceList]=useState([]);

  const getServices= async () => {
      await Axios.get('/cms/HHServices')
      .then(function (response) {
      if(response.data && response.data.data){
        const responseData=response.data.data.HHServices;
        if(responseData.length>0){
          setServiceList(responseData);
        }
        else{
          setServiceList([]);
        }
      }})
      .catch(function (error) {
        setServiceList([]);
      });
  };

  useEffect(() => {
    getServices();
  }, [])

  return (
    <div className="content-page">
      <section className="jtv-bestsell-section">
        <div className="container">
          <div className="slider-items-products">
            <div className="bestsell-block">
              <div className="jtv-block-inner">
                <div className="block-title">
                  <h2>Our Services</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="jtv-top-banner">
        <Container fluid>
          {
            serviceList.map(item => (
                <div key={item.id} className="jtv-cont-box" style={{ background: item?.bgColor ? `${item.bgColor}` : "#eee" }}>
                  <div className="service-icon"> <i className={item?.icon || "icon-diamond icons"} style={{ fontSize: 'x-large', color: item?.bgColor ? "#fff" : "#666" }}></i> </div>
                  <h4 style={{ color: item?.bgColor ? "#fff" : "#666" }}>{item?.title || "Office Supplies"}</h4>
                  <div className="jtv-line-bg" style={{ background: item?.bgColor ? "#fff" : "#666" }}></div>
                  <p style={{ color: item?.bgColor ? "#fff" : "#666" }}>{item?.description || "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod"}</p>
                </div>
              ))
          }
        </Container >
      </div >
      </div>
  );
};

export default OurServices;
